import {Component, forwardRef} from '@angular/core';
import {FormBuilder, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {InputAutocompleteComponent} from '../input-autocomplete/input-autocomplete.component';
import {TranslocoDirective} from '@jsverse/transloco';
import {UsCityService} from '../../../services/us-city.service';
import {UsCity} from '../../../services/model/us-city';

@Component({
  selector: 'app-us-city-autocomplete',
  templateUrl: '../input-autocomplete/input-autocomplete.component.html',
  styleUrls: ['../input-autocomplete/input-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UsCityAutocompleteComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [CommonModule, MatAutocompleteModule, ReactiveFormsModule, MatFormFieldModule,
    MatIconModule, TranslocoDirective, MatInputModule, MatSelectModule, MatSelectModule, MatIconModule, FormsModule]
})
export class UsCityAutocompleteComponent extends InputAutocompleteComponent<UsCity> {

  constructor(fb: FormBuilder, private usCityService: UsCityService) {
    super(fb);
  }

  override getPlaceholder(): string {
    return 'autocomplete.usCities.placeholder';
  }

  override getData(text: string): Observable<UsCity[]> {
    return this.usCityService.getAll(text);
  }

  override getDisplayFn(): (usCity: UsCity) => string {
    return (usCity: UsCity): string => {
      return usCity?.name || '';
    }
  }
}
